import { useEffect, useState } from 'react';
import { Modal, Form, Select, App } from 'antd';
import { documentService } from '@/services/documentService';
import { taskService } from '@/services/taskService';

interface Props {
  documentId: string;
  onClose: () => void;
  onLinked: () => void;
}

export function LinkTaskModal({ documentId, onClose, onLinked }: Props) {
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const [tasks, setTasks] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setLoading(true);
    taskService.list({ pageSize: 200 })
      .then(r => setTasks((r as any).items || []))
      .catch(() => message.error('Không tải được tasks'))
      .finally(() => setLoading(false));
    form.setFieldsValue({ linkType: 'RELATED' });
  }, []);

  const submit = async () => {
    const v = await form.validateFields();
    setSubmitting(true);
    try {
      await documentService.linkTask(documentId, v.taskId, v.linkType);
      message.success('Đã liên kết task');
      onLinked();
    } catch (e: any) {
      message.error(e.response?.data?.message ?? 'Lỗi');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open
      title="Liên kết với task"
      onCancel={onClose}
      onOk={submit}
      confirmLoading={submitting}
      okText="Liên kết"
      cancelText="Hủy"
      width={520}
    >
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item name="taskId" label="Task" rules={[{ required: true }]}>
          <Select
            showSearch
            optionFilterProp="label"
            placeholder="Tìm task theo mã hoặc tên..."
            loading={loading}
            options={tasks.map(t => ({
              value: t.id,
              label: `${t.code} — ${t.title}`,
            }))}
          />
        </Form.Item>

        <Form.Item name="linkType" label="Loại liên kết" rules={[{ required: true }]}>
          <Select options={[
            { value: 'RELATED', label: 'Liên quan — tài liệu tham khảo cho task' },
            { value: 'RESULT', label: 'Kết quả — tài liệu là sản phẩm của task' },
            { value: 'SOURCE', label: 'Nguồn — task được tạo từ tài liệu này' },
            { value: 'ATTACHMENT', label: 'Đính kèm — attachment của task' },
          ]} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
